/* @flow */
import idx from 'idx';
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';

import waitForPromises from 'lib/waitForPromises.jsx';
import Divider from 'components/Divider.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Group from 'entities/Group.js';
import ProfileHeaderView from '../ProfileHeaderView.jsx';
import ToastActions from 'actions/ToastActions';
import ParentChildSection from './ParentChildSection.jsx';
import JoinedClassesSection from './JoinedClassesSection.jsx';
import OfficeHoursPicker from 'settings/components/OfficeHoursPicker.jsx';
import OwnedClassesSection from './OwnedClassesSection.jsx';
import UserSchools from '../UserSchools';
import ChatSettingsActions from '../../actions/ChatSettingsActions';

import './UserProfileView.scss';

type Props = {
  router: Object,
  data: ReactApolloData<UserProfileViewQuery>,
};

function SchoolsSection() {
  return (
    <div className="UserProfileView-section">
      <UserSchools />
      <Divider size="large" />
    </div>
  );
}

class UserProfileView extends React.Component<Props> {
  // XXX until we have a good mechanism for GraphQL errors (e.g. re-auth)
  // https://apollographql.slack.com/archives/general/p1478732615013498
  // FIXME(turadg)

  static routePrefetch = [
    () => {
      ChatSettingsActions.loadOfficeHours();
    },
  ];

  componentWillReceiveProps(nextProps: Object) {
    if (!this.props.data.error && nextProps.data.error) {
      ToastActions.showDefaultErrorToast();
      console.warn(nextProps);
      console.error('GraphQL error');
    }
  }

  navToGroup = (group: Group) => {
    this.props.router.push(group.webUrl());
  };

  render() {
    const { data } = this.props;
    const isTeacher = idx(data.me, _ => _.role) === 'teacher';
    const isOrgPickerEligible = idx(data.me, _ => _.organization_picker_eligible);
    const canOwnGroups = idx(data.me, _ => _.permissions.can_own_groups);
    const twoWayMessagingEnabled = idx(data.me, _ => _.preferences.two_way_messaging);

    if (data.loading || data.error) {
      return <LoadingIndicator />;
    }

    return (
      <div className="UserProfileView">
        <ProfileHeaderView />
        <ParentChildSection />
        {isTeacher && (
          <div className="UserProfileView-section">
            <OfficeHoursPicker
              twoWayMessagingEnabled={twoWayMessagingEnabled}
              compact
              showToggleButton
              showToastMessages
              showIntroText
            />
            <Divider size="large" />
          </div>
        )}
        {isOrgPickerEligible && <SchoolsSection />}
        {canOwnGroups && <OwnedClassesSection onCreate={this.navToGroup} />}
        <JoinedClassesSection onJoin={this.navToGroup} />
      </div>
    );
  }
}

const withData = graphql(
  gql`
    query UserProfileView {
      me {
        id
        uuid
        role
        # TODO https://app.asana.com/0/52068106376728/221203365474362
        organization_picker_eligible
        permissions {
          can_own_groups
        }
        preferences {
          two_way_messaging
        }
      }
    }
  `
);

export { UserProfileView };
export default waitForPromises(withData(UserProfileView));
